// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1047) return "static/chunks/1047.c5e1d1767705d4db.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"2025":"83714e9ee8e20615","2504":"ba8927558ed0546d","3997":"e6018a2b9f27d361","5416":"094bc9efba966821","6066":"f87f86498dbdb19a","8972":"16d32c0bffcf3f27"}[chunkId] + ".js";
};